import { copyToClipboard } from '@merakiplace/utils';
import { useSearchParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import useKakaoShare from '@/hooks/useKakaoShare';

import namanLogo from './logo_naman_english_mainBlue.png';
import kakaoShareLogo from './logo_share_kakao.png';
import './App.css';
import linkShareLogo from './logo_share_link.png';

function App() {
  return <AppRouter />;
}

function AppRouter() {
  const [searchParams] = useSearchParams();
  const copyLink = searchParams.get('copyLink');

  const clickEvent = useKakaoShare(searchParams);

  const notify = () => toast('링크가 복사되었습니다.');

  const copyShareLink = async () => {
    if (!copyLink) {
      return;
    }
    try {
      await copyToClipboard(copyLink);
      notify();
    } catch {
      toast('링크 복사에 실패했어요. 다시 시도해주세요.');
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={namanLogo} className="App-logo" alt="logo" />
        <div className="App-description-container">
          <span className="App-description">어떤 방식으로 공유하시겠어요?</span>
        </div>
        <div className="App-share-container">
          <button
            type="button"
            className="App-share-button"
            onClick={copyShareLink}
            aria-label="링크 복사"
            disabled={!copyLink}
          >
            <img src={linkShareLogo} className="App-share-logo" alt="" />
          </button>
          <button
            type="button"
            className="App-share-button"
            onClick={clickEvent}
            aria-label="카카오톡으로 공유"
          >
            <img src={kakaoShareLogo} className="App-share-logo" alt="" />
          </button>
        </div>
      </header>
      <ToastContainer
        position="bottom-center"
        autoClose={700}
        hideProgressBar={false}
        newestOnTop={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        theme="dark"
      />
    </div>
  );
}

export default App;
